// @ts-check
"use strict";
import { put, select } from "redux-saga/effects";
import apiCall, { makeUrl } from "../../utils/apiCall";

/**
 * Track new signups with FirstPromoter.
 * This should only be called once per user, and only if the user is flagged as a new_signup.
 * @param {{
 *   user: import('../../InterfaceType/Interface').LocalUser
 * }} param0
 */
export function* trackUserSignup({ user }) {
  try {
    if (user.new_signup && window.$FPROM) {
      window.$FPROM.trackSignup(
        {
          email: user.last_known_email,
        },
        function () {},
      );
      yield put({ type: "MARK_USER_SIGNUP", user });
    }
  } catch (e) {
    console.warn("Failed to track user signup with FirstPromoter", e);
  }
}

/**
 * Mark user signup as tracked to avoid duplicate signup tracking.
 */
export function* markUserSignup() {
  const postNewUserSignupCall = /** @type {import('axios').AxiosInstance} */ (yield apiCall());
  yield postNewUserSignupCall.post(makeUrl("/new-user-signup"), {});
  const latestLocalUser = /** @type {import('../../InterfaceType/Interface').LocalUser} */ (
    yield select((state) => state.basic.localUser)
  );
  yield put({
    type: "SAVE_LOCAL_USER",
    user: { ...latestLocalUser, new_signup: false },
  });
}
